import { Group, Select } from '@mantine/core';

import { HeadingBlock } from '@/types';
import { FilterOption, InlineEditor, VariableOption } from '../InlineEditor';

interface HeadingBlockViewProps {
  block: HeadingBlock;
  onChange: (next: HeadingBlock) => void;
  variables: VariableOption[];
  filterOptions: FilterOption[];
}

const LEVEL_OPTIONS = ['1', '2', '3', '4', '5', '6'].map((v) => ({
  value: v,
  label: `H${v}`,
}));

export function HeadingBlockView({
  block,
  onChange,
  variables,
  filterOptions,
}: Readonly<HeadingBlockViewProps>) {
  return (
    <Group align="flex-start" gap="xs" wrap="nowrap">
      <Select
        size="xs"
        data={LEVEL_OPTIONS}
        value={String(block.level)}
        onChange={(value) => {
          if (value) {
            onChange({ ...block, level: Number(value) as HeadingBlock['level'] });
          }
        }}
        allowDeselect={false}
        style={{ width: 70, flexShrink: 0 }}
      />
      <div style={{ flex: 1, minWidth: 0 }}>
        <InlineEditor
          value={block.content}
          onChange={(content) => onChange({ ...block, content })}
          variables={variables}
          filterOptions={filterOptions}
          flavour="heading"
          placeholder="Heading text — type @ to insert a variable"
          ariaLabel="Heading content"
        />
      </div>
    </Group>
  );
}
